import axiosInstance from '../utils/axiosInstance';

const BASE_PATH = '/admin/branch-monthly-targets';

export async function listBranchMonthlyTargets(params = {}) {
  const response = await axiosInstance.get(BASE_PATH, { params });
  return response.data;
}

export async function bulkSaveBranchMonthlyTargets(payload) {
  const response = await axiosInstance.post(`${BASE_PATH}/bulk`, payload);
  return response.data;
}

export async function getMonthlyTargetKpi(targetId) {
  const response = await axiosInstance.get(`${BASE_PATH}/${targetId}/kpi`);
  return response.data;
}

export async function saveMonthlyTargetKpi(targetId, kpi) {
  const response = await axiosInstance.put(`${BASE_PATH}/${targetId}/kpi`, { kpi });
  return response.data;
}
